import { useState } from "react";
import { Search } from "lucide-react";

/*
 * A caixa de busca das listas.
 *
 * ┌──────────────────────────────────────────────────────────────────────────┐
 * │ O TEXTO DIGITADO FICA AQUI, E A URL RECEBE A CÓPIA APARADA.              │
 * │                                                                          │
 * │ O roteador aplica a navegação numa transição do React, e um `<input>`    │
 * │ controlado pela URL voltaria ao valor antigo a cada tecla, comendo       │
 * │ caractere e pulando o cursor. Aparar no valor controlado também comeria  │
 * │ o espaço entre "Clínica" e "São".                                        │
 * └──────────────────────────────────────────────────────────────────────────┘
 *
 * A URL manda quando muda por fora: o chip removido e o voltar do navegador limpam a caixa.
 */
export function CampoDeBusca({
  rotulo,
  valor,
  aoMudar,
  placeholder,
}: {
  /** Nome acessível. */
  rotulo: string;
  /** O filtro da URL. */
  valor: string | undefined;
  /** Recebe o texto aparado. Vazio remove o filtro. */
  aoMudar: (valor: string) => void;
  placeholder?: string;
}) {
  const daUrl = valor ?? "";
  const [texto, setTexto] = useState(daUrl);
  const [ultimaDaUrl, setUltimaDaUrl] = useState(daUrl);

  if (daUrl !== ultimaDaUrl) {
    setUltimaDaUrl(daUrl);
    if (daUrl !== texto.trim()) setTexto(daUrl);
  }

  return (
    <div className="relative flex-1 md:max-w-[420px]">
      <Search
        aria-hidden="true"
        className="pointer-events-none absolute left-2.5 top-1/2 size-4 -translate-y-1/2 text-texto-3"
      />
      <input
        type="search"
        aria-label={rotulo}
        placeholder={placeholder}
        value={texto}
        onChange={(evento) => {
          setTexto(evento.target.value);
          aoMudar(evento.target.value.trim());
        }}
        className="h-8 w-full rounded-controle border border-fio bg-superficie-2 pl-8 pr-3 text-corpo text-texto placeholder:text-texto-3"
      />
    </div>
  );
}
